import {
  container,
  defaultFont,
  primaryColor,
  defaultBoxShadow,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
} from '../../material-dashboard-react.jsx';
import { darkColor, lightColor } from '../../material-dashboard-react';

const headerStyle = (theme) => ({
  appBar: {
    backgroundColor: 'transparent',
    color: theme.palette.type === 'dark' ? lightColor : darkColor,
    boxShadow: 'none',
    borderBottom: '0',
    marginBottom: '0',
    position: 'absolute',
    width: '100%',
    paddingTop: '10px',
    zIndex: '1029',
    border: '0',
    borderRadius: '3px',
    padding: '10px 0',
    transition: 'all 150ms ease 0s',
    minHeight: '50px',
    display: 'block',
  },
  container: {
    ...container,
    minHeight: '50px',
  },
  flex: {
    flex: 1,
  },
  title: {
    ...defaultFont,
    lineHeight: '30px',
    fontSize: '18px',
    borderRadius: '3px',
    textTransform: 'none',
    color: 'inherit',
    margin: '0',
    '&:hover,&:focus': {
      background: 'transparent',
    },
  },
  appResponsive: {
    top: '8px',
  },
  primary: {
    backgroundColor: primaryColor,
    color: theme.palette.type === 'dark' ? lightColor : darkColor,
    ...defaultBoxShadow,
  },
  info: {
    backgroundColor: infoColor,
    color: theme.palette.type === 'dark' ? lightColor : darkColor,
    ...defaultBoxShadow,
  },
  success: {
    backgroundColor: successColor,
    color: theme.palette.type === 'dark' ? lightColor : darkColor,
    ...defaultBoxShadow,
  },
  warning: {
    backgroundColor: warningColor,
    color: theme.palette.type === 'dark' ? lightColor : darkColor,
    ...defaultBoxShadow,
  },
  danger: {
    backgroundColor: dangerColor,
    color: theme.palette.type === 'dark' ? lightColor : darkColor,
    ...defaultBoxShadow,
  },
});

export default headerStyle;
